import { api } from '@/lib/api'
import type { StopConfigUpdate, StopStatus } from '@/types/stop'

export async function getStopStatus(positionId: number): Promise<StopStatus> {
  const { data } = await api.get<StopStatus>(`/positions/${positionId}/stop-status`)
  return data
}

export async function updateStopConfig(
  positionId: number,
  body: StopConfigUpdate,
): Promise<StopStatus> {
  const { data } = await api.patch<StopStatus>(`/positions/${positionId}/stop`, body)
  return data
}
